import { Injectable } from '@angular/core';
import {
    PreloadingStrategy,
    Route,
} from '@angular/router';
import { AppStateFacade } from '@app-state';

import {
    Observable,
    of,
} from 'rxjs';

import { PageMetadataRegistry } from '../page-meta';

@Injectable({
    providedIn: 'root',
})
export class PreloadFeatureStrategy implements PreloadingStrategy {
    constructor(
        private _pageRegistry: PageMetadataRegistry,
        private _appState: AppStateFacade,
    ) { }

    public preload(route: Route, resolve: () => Observable<any>) {
        const page = this._pageRegistry.findByRoute(`/${route.path}`, true);

        if (!page) { return of(null); }

        const isFlagged = !!page.featureFlag;

        if (!isFlagged) { return resolve(); }

        const isFeatureEnabled = this._appState
            .settings
            .isFeatureEnabled(page.featureFlag!);

        if (isFeatureEnabled) { return resolve(); }

        return of(null);
    }
}
